import { ERegion } from '@constants';

import { branchesDataES, Branch, branchesDataPT } from '@/constants';
import { useProfile } from '@/store';
import { getBranchOptionsFrom, getDegreeOptionsFrom, getUniversityOptionsFrom } from '@/utils';

export const useUniStudyBranchesOptions = () => {
  const { profile } = useProfile();
  const dataMap: Record<ERegion, Branch[]> = {
    [ERegion.ES]: branchesDataES,
    [ERegion.PT]: branchesDataPT
  };
  const data: Branch[] = dataMap[profile?.regionConfig ?? ERegion.ES];

  return {
    getBranchOptions: () => getBranchOptionsFrom(data),
    getDegreeOptions: (selectedBranch: string | undefined, otherDegreeLabel: string) =>
      getDegreeOptionsFrom(data, selectedBranch, otherDegreeLabel),
    getUniversityOptions: (
      selectedBranch: string | undefined,
      selectedDegree: string | undefined,
      otherLabel: string
    ) => getUniversityOptionsFrom(data, selectedBranch, selectedDegree, otherLabel)
  };
};
